import { useMsal } from '@azure/msal-react';
import { Outlet } from 'react-router';

import LoadingPage from '../components/LoadingPage';

const EntraRequiredAuth = ({ isAuthenticatedToBackend }: { isAuthenticatedToBackend: boolean }) => {
  const { inProgress } = useMsal();

  if (inProgress !== 'none' && !isAuthenticatedToBackend) {
    return <LoadingPage message="Signing in to Entra" />;
  }

  // Making sure that authInfo and featureFlags are present
  if (!isAuthenticatedToBackend) {
    return <LoadingPage message="Signing in to AMP" />;
  }

  return <Outlet />;
};

export default EntraRequiredAuth;
